export const TOGGLE_SETTINGS_OPEN = "TOGGLE_SETTINGS_OPEN";
export const CLOSE_SETTINGS = "CLOSE_SETTINGS";
export const SETTINGS_ENABLED = "SETTINGS_ENABLED";
export const SET_ALL_DASHBOARDS = "SET_ALL_DASHBOARDS";
export const SET_LOGGED_IN = "SET_LOGGED_IN";
export const SET_NAVBAR_HIDDEN = "SET_NAVBAR_HIDDEN";
